<template>
<div id="expediente_archivosm" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Descarga Expediente" class="elevation-1 px-5 py-3" >
                    
              <div class="contenedor-tab-dev" >
                <v-card-text>
                    <v-card-title>
                        <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form2" lazy-validation>
                        <v-container grid-list-md text-xs-center>
                            <v-row row wrap>
                                <v-col sm="12" md="4" lg="4">
                                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                model.fecha_de = parseDate(model.fecha_de)
                                                                " v-mask="'####-##-##'" :rules="[                                                                
                                                                validaDias,
                                                                validaFecha,
                                                                ]">
                                            </v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu1 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col sm="12" md="4" lg="4">
                                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                    validaDias,
                                                    validaFecha,
                                                    ]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu2 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                    <v-col sm="12" md="2" lg="2">
                                    <v-switch
                                    v-model="model.fecha_pedimento"
                                    color="red darken-3" 
                                    :label="model.fecha_pedimento=='1'?'Buscar por: Fecha de Pedimento':'Buscar por: Fecha de Carga'"
                                    true-value="1" false-value="0"
                                ></v-switch>
                                    </v-col>
                                    <v-col sm="12" md="2" lg="2">
                                    &nbsp;
                                    </v-col>
                            </v-row>
                            <v-row no-gutters dense>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <v-text-field label="No. Pedimento" hint="Ejemplo: 240-0123-0000123" v-model="model.pedimento" :rules="[validaPedimento]" ></v-text-field>                                                                        
                                </v-col>
                                <v-col cols="12" sm="1" lg="1" class="pa-0 ps-2 pt-1" >
                                    <v-btn icon title="Pegar Listado" @click="dialog2 = !dialog2" v-tippy>
                                        <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                    </v-btn>
                                </v-col>                                
                            </v-row>  
                            <v-row row wrap>
                                <v-col sm="12" md="8" lg="8" v-if="model.es_grupo==0">
                                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado" 
                                        :item-text="getNombreGrupo" item-value="rfc" clearable label="Seleccione Emisor" ></v-autocomplete>
                                </v-col>
                                <v-col sm="12" md="8" lg="8" v-else >
                                    <v-autocomplete :hide-no-data="true" :items="clientesTransportista" v-model="rfc_cliente_seleccionado" 
                                        :item-text="getNombreCliente" item-value="rfc" clearable label="Seleccione Cliente" ></v-autocomplete>
                                </v-col>                                
                                <v-col sm="12" md="4" lg="4">
                                    <v-btn color="success" @click="generar_reporte_sqs()" >
                                        <v-icon>done_all</v-icon>Generar ZIP de Descarga
                                    </v-btn>
                                </v-col>
                            </v-row>                               
                        </v-container>
                    </v-form>
                </v-card-text>
                
                <v-card-text>
                    <v-refresh-button :funcion="cargarReportes" />                    
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                        </template>

                        <template slot="actions" slot-scope="props" >
                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-client-table>
                </v-card-text>
              </div>
                    
                 </base-material-card>


            </v-flex>
        </v-layout>
    </v-container>

    <v-divider></v-divider>
    <v-dialog v-model="dialog2" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined
                        rows="15"
                        v-model="listado"
                        :rules="[validaListado]"
                        ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
                <v-btn  small color="primary" @click="generaReporteListado();" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    data: () => ({
        gruposTransportistas:[],
        clientesTransportista:[],
        rfc_grupo_seleccionado:"",
        rfc_cliente_seleccionado:"",
        menu1:false,
        menu2:false,
        permisoEliminar: false,
        fab: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext"
            },
           
            {
                text: "Descarga Expediente",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
        datosPreview: [],
        dialog1: false,        
        dialog2: false,        
        listado:"",
        
        columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        show_loading: true,
        loadingAnios: true,
        loadingMeses: false,

        anios: [],
        meses: [],        
        operaciones: ["Exportaciones","Importaciones","Todas"],
        aduanas: [],
        patentes: [],
        pedimentos: [],
       
        model: {
            es_grupo:0,
            rfc: "",
            usuario: "",
            fecha_de:"",
            fecha_a:"",
            pedimento: "",
            fecha_pedimento: 0,
            reporte_url: "",
            nombre_reporte: "",
            tipo: "",
            tipo_documento: [],
        },        
        
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        }, 

        modal:false,
        
    }),

    methods: {        
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },

        getTransportistas: function(){            
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),                
            };
            axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;
                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getNombreCliente:function(row){
            if(row.metadato!=null && row.metadato!="")
                return row.rfc+" - "+row.metadato;
            else
                return row.rfc+" - "+row.razon_social;
        },
        getClientesTransportista: function(){
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),                
            };
            axios.post(this.$hostname+ "grupos/get_rfcs/", data)            
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        validaMes: function(){
            if (this.model.anio != 0 && (this.model.mes == null || this.model.mes == ""))
                return "Al menos ingrese el mes que desee consultar";
            return true;
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 dias. Favor de verificar.";
            }
            return true;
        },
        validaPedimento: function(){
            if (this.model.pedimento != ""){
                if (!this.validarPatronPedimento(this.model.pedimento))          
                    return "Pedimento no válido. Ejemplo: 240-0123-0000123";
                else 
                    return true;
            }
            if (this.model.fecha_de == null || this.model.fecha_de == "" || this.model.fecha_a == null || this.model.fecha_a == "" ){
                if( this.validaListado() === true)
                    return true;
                else
                    return "Debe ingresar un pedimento o rango de fechas";
            }
            
            return true;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaListado: function(){            
            var listadoSinEspacios = this.removerLineasVacias(this.listado);
            if (listadoSinEspacios.length == 0) {
                return "Ingrese al menos 1 pedimento. Favor de verificar.";
            } else if (listadoSinEspacios.length > 50){
                return "No se puede consultar mas de 50 pedimentos";
            } else {
                for(var k in listadoSinEspacios){
                    if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                        return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
                }
            } 
            
            return true;
        },       
        removerLineasVacias(listado){
            var listadoSplit = this.listado.split("\n");
            var listadoSinEspacios = listadoSplit.filter(item => {
                return item.trim() != "";
            });
            return listadoSinEspacios;
        },
        
        cargarReportes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Expediente ArchivosM"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterio(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes de expediente.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterio: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var criterio = "";
                    if (params.listado!= undefined && params.listado.length>0){
                        criterio += "Buscado por lista de pedimentos: "+params.listado.length;
                    } else if (params.pedimento!=undefined && params.pedimento != ""){
                        criterio += "Pedimento: " + params.pedimento;
                    } else {
                        if (params.fecha_de!=undefined && params.fecha_de != "")
                            criterio += "De: " + params.fecha_de;
                        if (params.fecha_a!=undefined && params.fecha_a != "")
                            criterio += " A: " + params.fecha_a;                        
                    }
                    if (params.rfc_emisor!=undefined && params.rfc_emisor != "")
                        criterio += ", Emisor: " + params.rfc_emisor;
                    if (params.rfc_cliente!=undefined && params.rfc_cliente != "")
                        criterio += ", Cliente: " + params.rfc_cliente;

                    return criterio;
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        
        getCarpeta: function(){
            var carpeta = "";
            if (this.model.anio != 0){
                //Ejemplo: AEM000515F97/pedimentos/2019/10/Exportaciones/730/3658/730-3658-9004587/
                carpeta = this.model.rfc.toUpperCase()+"/pedimentos/"+this.model.anio;
                if (this.model.mes != ""){
                    if (this.model.mes != "Todos")
                        carpeta += "/"+this.model.mes;                    
                }
            } 
            this.model.carpeta = carpeta;
            return carpeta;
        },

        generaReporteListado(){
            if (this.$refs.formListado.validate()) {
                this.generar_reporte_sqs();
                this.dialog1 = false;
                this.dialog2 = false;
            }            
        },
        
        generar_reporte_sqs() {      
            if (this.$refs.form2.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');   
                
                this.model.reporte_url = "/reportes_ws/expediente_archivosm/";
                this.model.nombre_reporte= "Expediente ArchivosM";
                this.model.tipo = "Expediente ArchivosM";
                
                var data = this.model;
                data["listado"] = this.removerLineasVacias(this.listado);    
                
                if(this.rfc_grupo_seleccionado!=null && this.rfc_grupo_seleccionado!="")
                    data["rfc_emisor"] = this.rfc_grupo_seleccionado;
                else 
                    data["rfc_emisor"] = "";

                if(this.rfc_cliente_seleccionado!=null && this.rfc_cliente_seleccionado!="")
                    data["rfc_cliente"] = this.rfc_cliente_seleccionado;
                else 
                    data["rfc_cliente"] = "";
                
                console.log(data);
                //return true;

                axios({
                        method: "post",
                        url: this.$hostname + "reportes_ws/valida_busqueda_expediente_archivosm/",     
                        //url: "http://127.0.0.1:7000/reportes_ws/valida_busqueda_expediente_archivosm/",
                        //url: "http://127.0.0.1:7000/reportes_ws/expediente_archivosm/",
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";                            
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.listado="";
                        this.cargarReportes();                    
                        this.$root.$dialogLoader.hide();
                    });          
            }  
        },
                
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
       
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);                        
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {                    
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
            if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,                
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportes();                                                             
                    });
            }
          });
        },
    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("id_usuario");
        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = this.$local_storage.get("rfc_grupo");         
            this.model.es_grupo = 1;  
            this.getClientesTransportista();          
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
            this.model.es_grupo = 0;
            this.getTransportistas();
        }
        
        var tipoUsuario = this.$local_storage.get("tipo_usuario");        
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
            this.permisoEliminar = true;            
                   
        this.cargarReportes();           
    }
};
</script>
<style>
#VueTables_th--actions {
        width: 115px;
    }        
</style>
<style scoped>
.table-bordered thead th, .table-bordered thead td {
    font-size: x-small !important;
}
</style>
